import { render } from "./RightSidebarLayout.vue?vue&type=template&id=0584f03d"
import script from "./RightSidebarLayout.vue?vue&type=script&lang=js"
export * from "./RightSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/student/RightSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0584f03d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0584f03d', __exports__)) {
    api.reload('0584f03d', __exports__)
  }
  
  module.hot.accept("./RightSidebarLayout.vue?vue&type=template&id=0584f03d", () => {
    api.rerender('0584f03d', render)
  })

}


export default __exports__